import {Component, inject, signal} from '@angular/core'
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog'
import {MatButton} from '@angular/material/button'
import {HttpClient} from '@angular/common/http'
import {MatFormField, MatInput, MatLabel} from '@angular/material/input'
import {FormsModule} from '@angular/forms'
import {tap} from 'rxjs'
import {IWaitComponentData, WaitComponent} from '@sparbanken-syd/sparbanken-syd-theme'

@Component({
  selector: 'spb-renew-cert',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule
  ],
  templateUrl: './renew-cert.component.html',
  styleUrl: './renew-cert.component.scss'
})
export class RenewCertComponent {

  public readonly token = signal<string>('')

  private readonly http = inject(HttpClient)

  private readonly dialog = inject(MatDialog)

  private dialogRef = inject(MatDialogRef)

  public sendRequest() {
    this.dialogRef.close()
    const url = `https://gitlab.com/api/v4/projects/77311869/ref/develop/trigger/pipeline?token=${this.token()}`
    const ref = this.dialog.open(WaitComponent, {
      data: {
        title: 'Startar',
        text: 'Startar rörledning'
      },
      disableClose: true
    })
    this.http.post(url, {})
      .pipe(
        tap((res: any) => {
          ref.close()
          this.dialog.open<WaitComponent, IWaitComponentData, void>(WaitComponent, {
            data: {
              title: 'Startat',
              html: `<p>Rörledningen har <a target="_blank" href="${res.web_url}">startat</a><p>`,
              closable: true
            }
          })
        })
      )
      .subscribe()
  }
}
